module.exports = __webpack_public_path__ + "static/media/lena.d5608646.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionGenius/medias/lena.png
// module id = 230
// module chunks = 0